import {Utilities} from '../../shared/utilities/utilities.model';
import {DigitalSignStartedProcess} from './digital-sign-started-process.model';
import {DigitalSignClause, DigitalSignClauses} from './digital-sign-clauses';
import {DigitalSignSimpleClauseModel} from './digital-sign-simple-clause.model';

export class DigitalSignOperatorStartedProcess extends DigitalSignStartedProcess{
	status: string;
	documents: DigitalSignProcessDocument[];

	constructor(model?: any) {
		super();
		if (!Utilities.isVoid(model)) {
			this.status = model.status;
			this.documents = [];
			if (!Utilities.isVoid(model.documents)) {
				for (let i = 0; i < model.documents.length; i++) {
					this.documents.push(new DigitalSignProcessDocument(model.documents[i]));
				}
			}
		}
	}
}

export class DigitalSignProcessDocument {
	id: string;
	name: string;
	status: string;
	url: string;
	type: string;
	signatures: DigitalSignProcessDocumentSignatures[];
	simpleClauses: DigitalSignSimpleClauseModel[];

	isAllChecked = false;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.id = model.id;
			this.name = model.name;
			this.status = model.status;
			this.url = model.url;
			this.type = model.type;
			this.signatures = [];
			this.simpleClauses = [];
			if (!Utilities.isVoid(model.signatures)) {
				for (let i = 0; i < model.signatures.length; i++) {
					const signatures = new DigitalSignProcessDocumentSignatures(model.signatures[i]);
					this.signatures.push(signatures);
					this.simpleClauses.push(new DigitalSignSimpleClauseModel(signatures.id, signatures.text, this.url, 1));
				}
			}
		}
	}

	setIsAllChecked() {
		if (!Utilities.isVoid(this.simpleClauses)) {
			for (let i = 0; i < this.simpleClauses.length; i++) {
				if (this.simpleClauses[i].values.includes(false)) {
					if (this.simpleClauses[i].id !== DigitalSignSimpleClauseModel.MODE_FIXED) {
						this.isAllChecked = false;
						return;
					}
					this.simpleClauses[i].values.fill(true);
				}
			}
		}
		this.isAllChecked = true;
	}
}

export class DigitalSignProcessDocumentSignatures {
	id: string;
	text: string;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.id = model.id;
			this.text = model.text;
		}
	}
}
